import React, { useState } from "react";
import { Badge } from "react-bootstrap";

const badgeColors = ["#F9F5FF", "#EFF8FF", "#EEF4FF"];
const badgeClasses = ["label1", "label2", "label3"];

export const BadgesComponent = ({ badges }) => {
  const [expanded, setExpanded] = useState(false);

  const visibleBadges = expanded ? badges : badges?.slice(0, 3);

  const toggleExpand = () => {
    setExpanded((prev) => !prev);
  };
  return (
    <div className="p-0 gap-1">
      {visibleBadges?.map((badge, index) => {
        const randomColor =
          badgeColors[Math.floor(Math.random() * badgeColors.length)];
        const randomClass =
          badgeClasses[Math.floor(Math.random() * badgeClasses.length)];

        return (
          <Badge key={index} bg={randomColor} className={randomClass}>
            {badge}
          </Badge>
        );
      })}

      {badges?.length > 3 && !expanded && (
        <Badge
          onClick={toggleExpand}
          bg="#F2F4F7"
          style={{ cursor: "pointer" }}
          className="label4"
        >
          +{badges.length - 3}
        </Badge>
      )}

      {expanded && badges?.length > 3 && (
        <Badge
          onClick={toggleExpand}
          bg="#F2F4F7"
          style={{ cursor: "pointer", color: "black" }}
        >
          Show less
        </Badge>
      )}
    </div>
  );
};
